<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";

import {SmartOfferBundleProgressiveType} from "@/modules/redactor/models/smart-offer/bundle-progressive/SmartOfferBundleProgressiveType";

export default {
  name: "r-smart-offer-bundle-progressive-type",
  props: {
    model: VueTypes.instanceOf(SmartOfferBundleProgressiveType),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferBundleProgressiveType.getValues();
    }
  }
}
</script>